module.exports = __webpack_public_path__ + "src/components/Home/SliderAnimation/arrow-down.png?7d9a5980";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/SliderAnimation/arrow-down.png
// module id = 3099
// module chunks = 8